import AgentAvatar from '../components/AgentAvatar';
import { useAgent } from '../hooks/useAgents';

export interface NudgeAgentIconProps {
  readonly agentId: string;
}

/**
 * Title-bar icon for a proactive nudge: the avatar of the agent that produced
 * the message (resolved from `agentId`), so the nudge is clearly attributed to
 * a specific agent rather than a generic notification glyph.
 */
export function NudgeAgentIcon({ agentId }: NudgeAgentIconProps) {
  const { data: agent } = useAgent(agentId);
  return <AgentAvatar agent={agent} size="xs" />;
}
